"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceDevServerEndpoint = exports.defaultDevServerPort = void 0;
exports.defaultDevServerPort = 65432;
var sliceDevServerEndpoint = function (_a) {
    var origin = _a.origin, packageName = _a.packageName;
    return "".concat(origin, "/api/slice/").concat(encodeURIComponent(packageName));
};
exports.sliceDevServerEndpoint = sliceDevServerEndpoint;
//# sourceMappingURL=constants.js.map